import React, { Component} from 'react'
import { observer } from 'mobx-react'
import Store from '../../store/ProductionTableStore'
import InfoIcon from '../icons/InfoIcon'
import Tooltip from 'react-tooltip-lite'

@observer
class TableTask extends Component {
    render() {
        const data = this.props.data
        const date = this.props.date
        const position = this.props.position
        const orderPosition = this.props.orderPosition
        const userId = Store.user.id
        let userTooltip = 'Slutför'
        
        // Data
        let articleNumber = ''
        let name = ''
        let productionTime = ''
        let productionInfo = null

        if (data.article) {
            
            name = data.article.name

            if (data.infoboarddata) {
                const infoboarddata = JSON.parse(data.infoboarddata)
                
                if (infoboarddata && infoboarddata.infoboardType == 6) {
                    name = infoboarddata.name
                }
            }

            articleNumber = data.article.article_number
            productionTime = data.article.prod_display_time
        }        

        if (data.productionInfo !== '') {
            productionInfo = <Tooltip
                content={ <span dangerouslySetInnerHTML={{ __html: data.productionInfo }}></span> }
                className="table__row__cell--info"
                direction="right"
            >
                <InfoIcon />
            </Tooltip>
        }

        if (data.done) {
            userTooltip = 'Slutförd'

            if (data.user) {
                userTooltip = `${ data.user.firstname } ${ data.user.lastname }`
            }
        }

        return <div className={ `table__row table__row--tasks ${ data.done ? 'table__row table__row--tasks--done' : '' }` }>
            <div className="table__row__cell table__row__cell__icon"></div>
            <div className="table__row__cell">{ articleNumber }</div>
            <div className="table__row__cell table__row__cell--lg">
                <span title={ name }>{ productionInfo } { name }</span>
            </div>
            <div className="table__row__cell table__row__cell--md"></div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right" style={{marginLeft: 10}}></div>
            <div className="table__row__cell table__row__cell--sm table__row__cell--right">{ data.quantity }</div>
            <div className="table__row__cell table__row__cell--right">{ data.value_amount }</div>
            <div className="table__row__cell table__row__cell--right">{ productionTime }</div>
            <div className="table__row__cell table__row__cell--right">{ data.remaining_display_time }</div>
            <div className="table__row__cell table__row__cell--right"></div>
            <div className="table__row__cell table__row__cell--right table__row__cell--last">
                <span>{ `${ data.taskPercentile }%` }</span>
                <Tooltip
                    direction="up-end"
                    content={ userTooltip }
                >
                    <label className="control control--checkbox">                        
                        <input
                            className="control__input"
                            type="checkbox"
                            checked={ data.done !== null ? true : false }
                            onChange={ Store.HANDLE_SET_TASKS_ASYNC.bind(this, date, position, orderPosition, userId) }
                        />
                        <div className={ `control__indicator ${ data.done ? 'control__indicator--light-green' : 'control__indicator--grey' }` }></div>
                    </label>
                </Tooltip>
            </div>            
        </div>
    }
}

export default TableTask
